var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { baseService } from './base.service';
const BASE_URL_API = (_a = process.env.REACT_APP_BASE_URL_API) !== null && _a !== void 0 ? _a : '';
const getMenusGenerated = (_a) => __awaiter(void 0, [_a], void 0, function* ({ page, size, leadId, restaurantName, country, }) {
    const params = new URLSearchParams({
        page: (page - 1).toString(),
        size: size.toString(),
        country: country !== null && country !== void 0 ? country : 'CO',
    });
    if (restaurantName)
        params.append('restaurantName', restaurantName);
    if (leadId)
        params.append('leadId', leadId);
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/menu-reviews-ms/menu-extraction/list`, {
        params,
    });
    return response.data;
});
const getHunterTopMenusGenerated = (country) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/menu-reviews-ms/menu-extraction/ranking`, {
        params: {
            countries: country,
        },
    });
    return response.data;
});
const getOwnStats = (country) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/menu-reviews-ms/menu-extraction/ranking/me`, {
        params: {
            countries: country,
        },
    });
    return response.data;
});
const generateMenu = (_a) => __awaiter(void 0, [_a], void 0, function* ({ restaurantName, hunterName, fileURL, country, leadId, }) {
    yield baseService
        .getServiceInstanceAuthorization()
        .post(`${BASE_URL_API}/rests-manager-gateway/cauth/api/menu-reviews-ms/menu-extraction/request`, {
        restaurant_code: leadId,
        restaurant_name: restaurantName,
        hunter_name: hunterName,
        menu_url: fileURL,
        country,
    });
});
const uploadFile = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('file', file);
    const response = yield baseService.getServiceInstanceAuthorization().post(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-self-onboarding/menu/resources/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data.presigned_url;
});
const deleteMenuGenerated = (id) => __awaiter(void 0, void 0, void 0, function* () {
    yield baseService
        .getServiceInstanceAuthorization()
        .delete(`${BASE_URL_API}/rests-manager-gateway/cauth/api/menu-reviews-ms/delete/${id.toString()}`);
});
const getAllowedCountries = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService.getServiceInstanceAuthorization().get(`${BASE_URL_API}/rests-manager-gateway/cauth/partners-selfservice/config-manager/settings/sob-menu-generator`);
    return response.data.settings;
});
export const menuGeneratorService = {
    getMenusGenerated,
    getHunterTopMenusGenerated,
    getOwnStats,
    generateMenu,
    uploadFile,
    deleteMenuGenerated,
    getAllowedCountries,
};
